<template>
  <div
    class="StaffChartBox"
    :class="{ showOneRow: dataLength > dataMaxShowLength }"
  >
    <div class="chart1">
      <div class="topBox">
        <div class="title">
          <img
            class="titleIcon"
            src="@/assets/images/xinyulou/icon_2.png"
            alt
          />
          <span>项目部数据对比</span>
          <el-tooltip
            class="item"
            effect="dark"
            content="默认展示上一个月的数据"
            placement="top"
          >
            <img class="tipsIcon" src="@/assets/images/xinyulou/tip_icon.png" />
          </el-tooltip>
        </div>
        <el-date-picker
          v-model="dateTime1"
          type="daterange"
          :picker-options="pickerOptions"
          :editable="false"
          start-placeholder="开始日期"
          range-separator="~"
          end-placeholder="结束日期"
          clearable
          :default-time="['00:00:00', '23:59:59']"
          size="small"
          @change="data1search"
        >
        </el-date-picker>
        <!-- <GlobalForm
        :form-item-list="formItemList1"
        round
        size="mini"
        :inline="true"
        @handleConfirm="data2search"
        confirm-btn-name="搜索"
      >
      </GlobalForm> -->
      </div>

      <div class="chartBox" v-loading="chartLoading1">
        <chart
          :options="chart1Option"
          :isResize="dataLength > dataMaxShowLength"
        />
      </div>
    </div>
    <div class="chart2">
      <div class="topBox">
        <div class="title">
          <img
            class="titleIcon"
            src="@/assets/images/xinyulou/icon_3.png"
            alt
          />
          <el-dropdown @command="typeChange">
            <span>
              {{ chartTypeList[chooseTypeIndex].name }}
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item
                v-for="(item, index) in chartTypeList"
                :key="item.type"
                :command="index"
                :style="{ color: chooseTypeIndex === index ? '#0981FF' : '' }"
                >{{ item.name }}</el-dropdown-item
              >
            </el-dropdown-menu>
          </el-dropdown>
          <el-tooltip
            class="item"
            effect="dark"
            content="默认展示上一个月的数据"
            placement="top"
          >
            <img class="tipsIcon" src="@/assets/images/xinyulou/tip_icon.png" />
          </el-tooltip>
        </div>
        <GlobalForm
          :init-data="formData"
          :form-item-list="formItemList2"
          round
          size="mini"
          :inline="true"
          :isButton="false"
        >
          <el-radio-group
            slot="radioBtns"
            v-model="chooseRadio"
            @change="data2search"
          >
            <el-radio-button
              :label="item.value"
              v-for="item in radioList"
              :key="item.value"
              >{{ item.name }}</el-radio-button
            >
          </el-radio-group>
        </GlobalForm>
      </div>

      <div class="chartBox" v-loading="chartLoading2">
        <chart
          :options="chart2Option"
          linearDir="row"
          :isResize="dataLength > dataMaxShowLength"
        />
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

import chart from "./main/chart";
import { _http } from "@/utils/request/storeStatistics";

let postionTime = Date.now(),
  startDate = null;

const pickerOptions = {
  onPick: ({ maxDate, minDate }) => {
    if (minDate && !maxDate) {
      startDate = minDate;
    } else {
      startDate = null;
    }
  },
  // 禁用日期函数【时间搜索框最多支持连续1个月的数据】
  disabledDate: (time) => {
    // 1. 禁止选择今天以后的日期
    // if (time.getTime() > postionTime) return true;

    // 2. 已选开始日期，则禁止超过 31 天的日期
    if (startDate) {
      const maxAllowDate = new Date(startDate);
      const minAllowDate = new Date(startDate);
      maxAllowDate.setDate(maxAllowDate.getDate() + 31);
      minAllowDate.setDate(maxAllowDate.getDate() - 31);
      return !(time <= maxAllowDate && time >= minAllowDate);
    }

    return false;
  },
};
export default {
  components: {
    chart,
  },
  data() {
    return {
      // == 图表1
      dateTime1: "",
      pickerOptions,

      // == 图表2
      formData: { date: "" },
      formItemList2: [
        {
          slotName: "radioBtns",
        },
        {
          type: "pickerOptions",
          labelName: "",
          pickerOptions,
          key: "date",
          clearable: true,
        },
      ],

      radioList: [
        {
          name: "询价量",
          value: "01",
        },
        {
          name: "回收金额",
          value: "02",
        },
        {
          name: "回收量",
          value: "03",
        },
      ],
      chooseRadio: "01", // 01询价；02回收金额；03回收量
      // 01前十；02后十
      chartTypeList: [
        {
          name: "门店top前10排行",
          type: "01",
        },
        {
          name: "门店top后10排行",
          type: "02",
        },
      ],
      chooseTypeIndex: 0,

      chart1Option: {},
      chartLoading1: false,

      chart2Option: {},
      chartLoading2: false,

      // 当前项目部对比数据最大显示的门店书数
      // 当大于当前数时，显示一行，且启用图表缩放功能
      dataMaxShowLength: 7,
      dataLength: 0, // 当前的数据长度
    };
  },
  watch: {
    // 时间切换筛选
    "formData.date"(val) {
      this.data2search();
    },
  },
  methods: {
    // 第一个图表进行搜索
    data1search() {
      if (this.chartLoading1) {
        return;
      }
      this.chartLoading1 = true;
      const series = [
          {
            data: [],
            type: "bar",
            name: "回收量",
          },
          {
            data: [],
            type: "bar",
            name: "回收金额",
          },
          {
            data: [],
            type: "bar",
            name: "返佣",
          },
        ],
        xAxisData = [];
      const resDt = {
        startTime: "",
        endTime: "",

        areaId: 0,
        companyId: 0,
        inspectorId: 0,
        pageNum: 0,
        pageSize: 0,
        storeId: 0,
        tagId: 0,
      };

      if (this.dateTime1 && this.dateTime1.length > 0) {
        resDt.startTime = moment(this.dateTime1[0]).format();
        resDt.endTime = moment(this.dateTime1[1]).format();
      }
      _http
        .statisticsCompany(resDt)
        .then((res) => {
          if (res.code === 1) {
            // const data = [...res.data, ...res.data];
            const data = res.data;
            for (let i = 0; i < data.length; i++) {
              const item = data[i];
              series[0].data.push(item.dealCount || 0); // 回收量
              series[1].data.push(item.dealPrice || 0); // 回收金额
              series[2].data.push(item.rebateAfter || 0); // 返佣
              xAxisData.push(item.name);
            }

            const option = {
              xAxis: {
                type: "category",
                data: xAxisData,
                axisLabel: {
                  // interval: 1,
                  minInterval: 1,
                  formatter: function(params) {
                    // 需求：每MAX_CHAR个字换行，最多MAX_LINE行，超出显示...
                    const MAX_CHAR = 8; // 每行最多8个字
                    const MAX_LINE = 2; // 最多2行

                    let res = "";
                    let start = 0;

                    for (let i = 0; i < MAX_LINE; i++) {
                      if (start >= params.length) break;

                      const end = start + MAX_CHAR;
                      let substr = params.substring(start, end);

                      // 如果是最后一行，且还有文字没显示 → 加省略号
                      if (i === MAX_LINE - 1 && end < params.length) {
                        substr += "...";
                      }

                      res += substr;
                      start = end;

                      // 不是最后一行就换行
                      if (i < MAX_LINE - 1 && start < params.length) {
                        res += "\n";
                      }
                    }
                    return res;
                  },
                  // rotate: 30, // 倾斜角度 30°/45° 都可以
                  overflow: "truncate", // 超长截断
                  ellipsis: "...", // 截断后显示省略号
                  show: true,
                  color: "#333333",
                },
              },
              series,
            };

            // 若数据数量大于7条，启用图表缩放功能
            this.dataLength = data.length;
            if (data.length > this.dataMaxShowLength) {
              option.dataZoom = [
                {
                  type: "inside",
                  minSpan: 1,
                  maxSpan: 100,
                  minValueSpan: 4,
                  maxValueSpan: 150,
                },
                {
                  type: "slider",
                },
              ];
            }

            this.chart1Option = option;
          }
        })
        .finally(() => (this.chartLoading1 = false));
    },
    // 第二个图表进行搜索
    data2search() {
      if (this.chartLoading2) {
        return;
      }

      const findRadio =
        this.radioList.find((r) => r.value === this.chooseRadio) || {}; // 选中类型
      let series = [
          {
            name: findRadio.name || "",
            type: "bar",
            data: [],
          },
        ],
        yAxisData = [];

      this.chartLoading2 = true;
      const resDt = {
        contentType: this.chooseRadio, // 类型
        startTime: "",
        endTime: "",
        sortType: this.chartTypeList[this.chooseTypeIndex].type, // 排行正序倒序
      };

      if (this.formData.date && this.formData.date.length > 0) {
        resDt.startTime = moment(this.formData.date[0]).format();
        resDt.endTime = moment(this.formData.date[1]).format();
      }
      _http
        .topRank(resDt)
        .then((res) => {
          if (res.code === 1) {
            const data = res.data;
            for (let i = 0; i < data.length; i++) {
              const item = data[i];
              yAxisData.unshift(item.name);
              series[0].data.unshift(Number(item.data) || 0);
            }
            // console.log("返回的参数：", findRadio, res);
            // series[0].data.sort();
            this.chart2Option = {
              yAxis: {
                type: "category",
                data: yAxisData,
              },
              series,
            };
          }
        })
        .finally(() => (this.chartLoading2 = false));
    },
    typeChange(index) {
      if (this.chartLoading2) return;
      this.chooseTypeIndex = index;
      this.data2search();
    },
  },
  mounted() {
    this.data1search();
    this.data2search();
  },
};
</script>

<style lang="scss" scoped>
.StaffChartBox {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding: 20px 0;

  /deep/ .el-form-item--mini.el-form-item {
    margin-bottom: 0;
  }

  &.showOneRow {
    .chart1,
    .chart2 {
      width: 100%;
    }

    .chart2 {
      margin-top: 20px;
    }
  }

  .chart1,
  .chart2 {
    width: 49.4%;
    // width: 100%;
    background: #ffffff;
    border-radius: 10px;
    /deep/ .el-radio {
      margin-right: 10px;
    }
  }

  .topBox {
    min-height: 54px;
    padding: 20px 20px 0;
    margin-bottom: 3px;
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .title {
    min-width: 210px;
  }
  .title > span,
  .el-dropdown-selfdefine {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #333333;
    line-height: 22px;
    vertical-align: middle;
  }
  .el-dropdown {
    color: #000;
    cursor: pointer;
  }
  .chartBox {
    height: 478px;
  }

  .filter {
    display: flex;
    padding-bottom: 10px;
    > .date {
      width: 240px;
      padding: 0 10px;

      /deep/ .el-range-separator {
        width: 20px;
      }
    }
  }
}
</style>
